import { ActionButtonType } from "@enums/actionButtonType";
import { ArtistVerified } from "@enums/artistVerified";
import banArtist from "@services/Artist/banArtist";
import featureArtist from "@services/Artist/featureArtist";
import verifyArtist from "@services/Artist/verifyArtist";
import { useEffect, useState } from "react";
import TObjectFilledWithStrings from "types/Shared/objectFilledWithStrings";

interface IUseListArtistProps {
  isBanOrFeatureModalOpen: boolean;
  isVerifyModalOpen: boolean;
  handleBan: () => void;
  handleVerify: (newVerify: ArtistVerified) => void;
  handleFeature: () => void;
  handleIsBanOrFeatureModalOpen: () => void;
  handleIsVerifyModalOpen: () => void;
  actionButtonType?: ActionButtonType;
}

const useListArtist = (
  basicData: TObjectFilledWithStrings | undefined,
  getItems: () => void
): IUseListArtistProps => {
  const [isBanOrFeatureModalOpen, setIsBanOrFeatureModalOpen] = useState(false);
  const [isVerifyModalOpen, setIsVerifyModalOpen] = useState(false);
  const [actionButtonType, setActionButtonType] = useState<ActionButtonType>();

  const handleBan = async () => {
    if (basicData?.uuid) {
      banArtist(basicData.uuid)
        .then(() => getItems())
        .finally(() => handleIsBanOrFeatureModalOpen());
    }
  };

  const handleVerify = async (newVerified: ArtistVerified) => {
    if (basicData?.uuid) {
      verifyArtist(basicData?.uuid, newVerified)
        .then(() => getItems())
        .finally(() => handleIsVerifyModalOpen());
    }
  };

  const handleFeature = async () => {
    if (basicData?.uuid) {
      featureArtist(basicData.uuid)
        .then(() => getItems())
        .finally(() => handleIsBanOrFeatureModalOpen());
    }
  };

  const handleIsBanOrFeatureModalOpen = () => {
    setIsBanOrFeatureModalOpen(!isBanOrFeatureModalOpen);
  };

  const handleIsVerifyModalOpen = () => {
    setIsVerifyModalOpen(!isVerifyModalOpen);
  };

  useEffect(() => {
    if (basicData?.uuid) {
      if (basicData?.actionButtonType === ActionButtonType.Verify) {
        setActionButtonType(ActionButtonType.Verify);
        handleIsVerifyModalOpen();
      } else if (basicData?.actionButtonType === ActionButtonType.Ban) {
        setActionButtonType(ActionButtonType.Ban);
        handleIsBanOrFeatureModalOpen();
      } else {
        setActionButtonType(ActionButtonType.Feature);
        handleIsBanOrFeatureModalOpen();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicData]);

  return {
    isBanOrFeatureModalOpen,
    isVerifyModalOpen,
    handleBan,
    handleVerify,
    handleFeature,
    handleIsBanOrFeatureModalOpen,
    handleIsVerifyModalOpen,
    actionButtonType,
  };
};

export default useListArtist;
